<!--首页-->
<template>
	<div>
		<div class="box">
			<div class="activity-detail-top">
				<div class="top-info">
					<div class="info-top-box">
						<img src="../../assets/images/activity/pic-logo1@2x.png" alt="" srcset="">
						<div class="activity-detail-title">2020年全国啦啦操公开赛</div>
						<div class="activity-detail-desc">2019年亚太啦啦操公开赛于10月31日-11月4日在深圳信息职业技术学院体育馆隆重举行。</div>
					</div>
					<div class="info-main-box">
						<div class="activity-dynamic"><span>动态</span><span>111</span> · <span>互动</span><span>222</span></div>
						<div class="info-dynamic-items">
							<div class="dynamic-item">
								<img src="../../assets/images/activity/pic-shuo-1@2x.png" alt="">
								<div class="dynamic-item-title">公告</div>
							</div>
							<div class="dynamic-item">
								<img src="../../assets/images/activity/pic-shuo-2@2x.png" alt="">
								<div class="dynamic-item-title">出场顺序</div>
							</div>
							<div class="dynamic-item">
								<img src="../../assets/images/activity/pic-shuo-3@2x.png" alt="">
								<div class="dynamic-item-title">图片|直播</div>
							</div>
							<div class="dynamic-item">
								<img src="../../assets/images/activity/pic-shuo-4@2x.png" alt="">
								<div class="dynamic-item-title">成绩查询</div>
							</div>
						</div>
					</div>
					<div class="info-bottom-box">
						<img src="../../assets/images/activity/icon-shuo-notice@2x.png" alt="">
						<div style="width:1px;height:15px;background:rgba(0,0,0,1);opacity:0.16;"></div>
						<div class="start-immediately">赛事马上开始咯~</div>
					</div>
				</div>
			</div>
			
			<van-tabs v-model="active" animated class="active-tab" sticky>
				<van-tab v-for="(item,index) in activeTab"  :key="index">
					<template #title> <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span>{{item.name}} </template>
					<div v-if="item.name=='动态'">
						<div class="acitve-items">
							<div class="active-items-title-read">
								<div class="active-item-title">2020年全国啦啦操公开赛日程安排及通知公告</div>
								<div class="active-itme-read">211阅读</div>
							</div>
							<div class="active-item-pics">
								<img src="../../assets/images/activity/pic-logo1@2x.png" alt="">
							</div>
						</div>
						<div class="video-items">
							<div class="active-item-title">首届中国啦啦操文化节视频直播</div>
							<div class="video-box">
								<img src="../../assets/images/activity/pic-logo1@2x.png" alt="">
							</div>
							<div class="video-bottom">
								<span>2019总决赛</span> 
								<span>235432人阅读</span>
							</div>
						</div>

						<div class="comments-items">
							<div class="detail-header">
								<div class="user-face">
								<!-- <img :src="userInfo.face" /> -->
									<img src="../../assets/images/activity/pic-logo1@2x.png" alt="" srcset="">
								</div>
							<div class="user-info">
								<div class="user-names">冠顶饺</div>
								<div class="look-info">{{1590123456 | getTimeFormat}}</div>
							</div>
							<div class="bottom-right" ></div>
							</div>
							<!-- <div class="activity-desc" v-html="diaryDetail.content"></div> -->
							<div class="activity-desc" >
								冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！冠顶饺，象小船，故又名“金山三船饺"！美餐，美味，美食！
							</div>
							<div class="activity-detail-bottom">
								<div class="activity-place-box">
									<img src="../../assets/images/activity/Shape@2x.png" alt="">
									<div class="activity-place">南京新街口</div>
								</div>
								<div class="release-time"><span>{{1590045030 | getTimeFormat}}</span><span><img src="../../assets/images/activity/icon-comments.png" alt=""></span></div>
							</div>

							<div class="comments-detail">
								<div class="comments-detail-top"></div>
								<div class="zan-box">
									<span class='zan-num'>90赞</span>
									<img class="user-zan-face" v-for="i in 4" :key="i" src="../../assets/images/activity/pic-logo1@2x.png" alt="">
								</div>
								<div class="user-comments" style="padding-left:10px">
									<span class="comments-user-name">GOODBAY</span> :
									<span class="comments-user-desc">怎么了</span>
								</div>
								<div class="user-reply-comments" style="padding-left:10px">
									<span class="comments-user-name">我</span> 回复
									<span class="comments-user-name">GOODBAY</span> :
									<span class="comments-user-desc">怎么了</span>很好
								</div>
							</div>
							
						</div>

					</div>
					<div v-if="item.name=='图片'">
						22
					</div>
				</van-tab>
			</van-tabs>
 
		</div>

	</div>
</template>
<style scoped>
	/* @import '../../assets/style/index.css'; */
	.comments-detail-top{
		width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom: 5px solid #F3F3F3;
	position:absolute;
	top: -10px;
	left: 10px;
	}
	.comments-user-desc{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:#333333
	}
	.comments-user-name{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:#586B94; 
	}

.zan-box{display: flex;flex-direction: row-reverse;padding:5px 10px;border-bottom: 1px solid #E6E6E6;}

	.user-zan-face{width: 22px;height: 22px;border-radius: 22px;margin-right: 4px;}
.zan-num{padding:1px 5px;
	font-size:11px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(102,102,102,1);line-height: 20px;}
	.comments-detail{
		background:#F3F3F3;
		margin-left: 40px; 
		border-radius: 5px; 
		padding-bottom: 10px;
		position: relative;
	}
	.activity-desc{
		padding-left: 40px;
	}
.activity-detail-bottom{padding-left: 40px;margin-top: 10px;}
.activity-place-box{
	display: flex;
	align-items: center;
	 
}
.release-time{
	font-size: 12px;
  	font-family: PingFangSC-Regular, PingFang SC;
  	font-weight: 400;
  	color: rgba(190, 190, 190, 1);
	margin-left: 5px;
	display: flex;justify-content: space-between;}
.release-time img{width: 28px;height: 26px;}
.activity-place-box img{width: 15px;height: 20px;}
.activity-place{
	font-size: 12px;
  	font-family: PingFangSC-Regular, PingFang SC;
  	font-weight: 400;
  	color: rgba(190, 190, 190, 1);
	margin-left: 5px;
}
	.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1)
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
	.video-bottom{
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
		margin-top: 5px;
	}
	.video-box img{margin-top: 10px;width: 100%;}
	.active-items-title-read{display: flex;justify-content: space-between;flex-direction: column;width: 58%;}
	.active-item-title{
		 
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1); 
	}
	.active-item-pics{width: 40%;}
	.active-item-pics img{width: 100%;height: 1.4rem;}
	.acitve-item-title{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
	}
	.active-itme-read{ 
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
	}
	.acitve-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;display: flex;justify-content: space-between;}
	.video-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;}
	.comments-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;}
	.active-tab{margin-top: 0.6rem;}
	.active-tab-num{width: 0.34rem;height: 0.34rem;background:#F05656;text-align: center;line-height: 0.34rem;display: block;position: absolute;right: -10px;top: -10px;border-radius: 0.34rem;
		color: #fff;}
	.active-tab >>>.van-tab__text{position: relative;}
	.active-tab >>>.van-tabs__nav{background: #F8F8F8;}
	.active-tab >>> [class*=van-hairline]::after{border-top: none;}
	.activity-detail-top{width: 100%;background-size: 100% 4.69rem;background: url('../../assets/images/activity/pic-shuo-top-1@2x.png') no-repeat;
		background-size: 100%;position:relative;overflow: hidden;}
	.top-info{width:6.9rem;height: 5.3rem;;background:rgba(255,255,255,1);border-radius:7px;margin: 2.1rem auto;margin-bottom: 0;display: flex;flex-direction: column;}
	.info-top-box{height: 1.45rem;padding: 0.26rem;border-bottom: 1px solid rgba(0,0,0,0.1);position: relative;}
	.info-top-box img{width:1.08rem;height: 1.08rem; position: absolute;top: -0.36rem;}
	.activity-detail-title{font-size:19px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:rgba(0,0,0,1);margin: 5px 0; text-indent: 1.34rem;}
	.activity-detail-desc{font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);line-height:18px;}
	.info-main-box{height:2.4rem;border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;flex-direction: column;}
	.activity-dynamic{
		height:33px;
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1);
		line-height:33px;
		text-indent: 0.28rem;
	}
	.info-dynamic-items{display: flex;justify-content: space-between;flex:1}
	.info-dynamic-items .dynamic-item{width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;}
	.dynamic-item img{width: 0.6rem;height: 0.6rem;display: block;margin-bottom: 0.12rem;}
	
	.info-bottom-box{flex: 1;display: flex;align-items: center;}
	.info-bottom-box img{width: 24px;height: 24px;display: block;margin: 0 0.16rem 0 0.28rem;}
	.start-immediately {font-size:14px;font-family:PingFangSC-Regular,PingFang SC; font-weight:400; color:rgba(0,0,0,1); margin-left: 0.14rem;}
	.box {
		background: #F8F8F8;
		padding-bottom: 50px;
		overflow: hidden;
	}



</style>

<script>
	import Vue from 'vue'; 
	import { Tab, Tabs } from 'vant';
	Vue.use(Tab).use(Tabs);
	  

	export default {
		name: 'ActivityList',
		components: { 
			 
		},
		data: function () {
			return {
				active:0,
				 activeTab:[{name:'动态',num:0},{name:'通知公告',num:9},{name:'视频',num:0},{name:'图片',num:9},{name:'更多',num:0}],

			}
		},
		filters: {
			getTimeFormat(valueTime) { 
				if (valueTime) {
				// let newData = Date.parse(new Date() + '')
				// let diffTime = Math.abs(newData - valueTime)
				let diffTime = Math.abs(
					new Date().getTime() - new Date(valueTime*1000).getTime()
				);
				if (diffTime > 7 * 24 * 3600 * 1000) {
					let date = new Date(valueTime);
					// let y = date.getFullYear()
					let m = date.getMonth() + 1;
					m = m < 10 ? "0" + m : m;
					let d = date.getDate();
					d = d < 10 ? "0" + d : d;
					let h = date.getHours();
					h = h < 10 ? "0" + h : h;
					let minute = date.getMinutes();
					let second = date.getSeconds();
					console.log(second);
					minute = minute < 10 ? "1" + minute : minute;
					second = second < 10 ? "0" + second : second;
					return m + "-" + d + " " + h + ":" + minute;
				} else if (
					diffTime < 7 * 24 * 3600 * 1000 &&
					diffTime > 24 * 3600 * 1000
				) {
					// //注释("一周之内");
					// var time = newData - diffTime;
					let dayNum = Math.floor(diffTime / (24 * 60 * 60 * 1000));
					return dayNum + "天前";
				} else if (diffTime < 24 * 3600 * 1000 && diffTime > 3600 * 1000) {
					// //注释("一天之内");
					// var time = newData - diffTime;
					let dayNum = Math.floor(diffTime / (60 * 60 * 1000));
					return dayNum + "小时前";
				} else if (diffTime < 3600 * 1000 && diffTime > 0) {
					// //注释("一小时之内");
					// var time = newData - diffTime;
					let dayNum = Math.floor(diffTime / (60 * 1000));
					return dayNum + "分钟前";
				}
			}
      }
		},
		mounted() {
			document.title = '活动';
			 
			// this.fetch()
		},
		destroyed() {
		},
		methods: {
			


		}
	}
</script>



// WEBPACK FOOTER //
// ActivityList.vue?0571520f